module.exports = __webpack_public_path__ + "static/img/mask_prd_soldout.962c6cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/atmosphere-mask/images/mask_prd_soldout.png
// module id = L0D0
// module chunks = 0